import ContentSimpleView from './ContentSimpleView'

export default ContentSimpleView
